import { GenericTableFactory } from "@/components/_Shared/Table/Classes/Factory"
import { RouteButton } from "@/components/Buttons"

export function BidListMain() {
    const table = GenericTableFactory.createBidTable()

    return(
        <>
            <div className="pt-5 pl-5">
                <h1>Bids</h1>
            </div>

            {table.RenderTable()}

            <div className="flex flex-row justify-center gap-3 m-2">
                <RouteButton route={"/main_menu"} text="Back"/>
            </div>

        </>
    )
}